export default {"src":"/_next/static/media/twitter.83a8474a.svg","height":400,"width":400};